module.exports = __webpack_public_path__ + "static/media/VG_logo_long.82b692d2.png";